import type { FileModel, FileModelFR } from './FileModel';
import { translateFileModel, translateFileModelArray } from './FileModel';

export type DirsModelFR = {
  fichierDIRS: FileModelFR;
  contenuDIRS: string;
  annexes: FileModelFR[];
};

export type DirsModel = {
  file: FileModel;
  content: string;
  annexes: FileModel[];
};

export const translateDirsModel = (d: DirsModelFR): DirsModel => {
  return {
    file: d.fichierDIRS && translateFileModel(d.fichierDIRS),
    content: d.contenuDIRS,
    annexes: d.annexes && translateFileModelArray(d.annexes),
  };
};
